import React, { useContext, useEffect, useState } from 'react'
import { IdentityContext } from '#src/containers/Identity'
import { getGuestCartContents } from '#src/services/cart'
import LoggedInCartOrderObserver, { LoggedInCartContextType } from './LoggedInCartObserver'
import GuestCartObserver, { GuestCartContext } from './GuestCartObserver'

const LoggedInCartContext = React.createContext<LoggedInCartContextType>({ order: undefined })
const LoggedInCartConsumer = LoggedInCartContext.Consumer

const GuestCart = React.createContext<GuestCartContext>({
  data: {
    order: getGuestCartContents(),
    syncOrder: () => getGuestCartContents(),
    removeGuestCartItem: () => null,
    addGuestCartItem: () => null,
    updateGuestCartItemQuantity: () => null
  }
})

const GuestCartConsumer = GuestCart.Consumer

// Grouped Provider
const CartProvider: React.SFC<{}> = ({ children }) => {
  const { myself } = useContext(IdentityContext)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  if (!myself) {
    return (
      <GuestCartObserver loading={loading}>
        {props => (
          <GuestCart.Provider
            value={{
              ...props
            }}
          >
            {children}
          </GuestCart.Provider>
        )}
      </GuestCartObserver>
    )
  } else {
    return (
      <LoggedInCartOrderObserver>
        {props => (
          <LoggedInCartContext.Provider value={props}>{children}</LoggedInCartContext.Provider>
        )}
      </LoggedInCartOrderObserver>
    )
  }
}

export { CartProvider, LoggedInCartConsumer, GuestCartConsumer, LoggedInCartContext }
